import { makeAutoObservable } from 'mobx'

import type { DropdownNode } from '../models/DropdownNode.model'

export class DropdownStore<DropdownNodeT extends DropdownNode = DropdownNode> {
  private _dropdownMap = new Map<string, DropdownNodeT>()

  get dropdownList() {
    return [...this._dropdownMap.values()]
  }

  constructor(dropdownList?: DropdownNodeT[]) {
    makeAutoObservable(this)
    if (dropdownList) {
      this.setDropdownList(dropdownList)
    }
  }

  setDropdownList(dropdownList: DropdownNodeT[]) {
    dropdownList.forEach((node) => {
      this._dropdownMap.set(node.id, node)
    })
  }

  updateCheckedNodes(id: string, options: { multiple?: boolean } = { multiple: false }) {
    if (options.multiple) {
      const node = this._dropdownMap.get(id)
      if (node) {
        node.updateChecked(!node.checked)
      }
      return
    }
    this._dropdownMap.forEach((node) => node.updateChecked(false))
    const targetNode = this._dropdownMap.get(id)

    if (targetNode) {
      targetNode.updateChecked(true)
    }
  }
}
